import { memo, useMemo } from 'react';
import { renderMarkdown } from '../lib/markdown';

/**
 * Settled assistant blocks only (SPEC §10). Memoized on `source`, so a growing
 * transcript never re-parses markdown it has already parsed — the live tail is
 * rendered as plain text by the caller precisely so this component's input is
 * stable once a block is done.
 */
export const Markdown = memo(function Markdown({ source }: { source: string }): JSX.Element {
  const html = useMemo(() => renderMarkdown(source), [source]);
  // Sanitized by `renderMarkdown`: raw HTML is escaped at parse time and the
  // result passes a tag/attribute/URI allowlist.
  return <div className="md" dangerouslySetInnerHTML={{ __html: html }} />;
});
